import { onBeforeUnmount, computed } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'

export default function useSocket () {
  const { state, commit } = useStore()
  const route = useRoute()

  const token = computed(() => state.auth.token)
  const tasks = computed(() => state.task.tasks)
  const user = computed(() => state.profile.user)
  const taskMessages = computed(() => state.chat.taskMessages)

  const isTaskBoard = computed(() => route.name === 'TaskBoard' || route.name === 'TaskBoardTeam')
  const isWeekPlanner = computed(() => route.name === 'WeekPlanner' || route.name === 'WeekPlannerTeam')

  let ws = null
  let needReconnection = true

  function initSocket () {
    if (ws) {
      ws.onopen = ws.onopen = ws.onerror = null
      ws.close()
    }

    ws = new WebSocket(`${process.env.VUE_APP_WEBSOCKET}?auth=${token.value}`)

    ws.onmessage = ({ data }) => {
      const parsedData = JSON.parse(data)

      if (parsedData.name === 'test') {
        console.log(parsedData.payload)
      }

      if (parsedData.name === 'chat' && parsedData.payload?.message) {
        const message = parsedData.payload.message

        const task = tasks.value.find(t => t.chat?.id === message.chatId)

        if (task) {
          const messages = task.chat.messages || []
          messages.push(message)

          commit('updateTask', {
            id: task.id,
            chat: {
              ...task.chat,
              messages: messages
            }
          })
        }

        if (taskMessages.value.some(i => i.chatId === message.chatId) && message.user.id !== user.value.id) {
          commit('setTaskMessage', message)
        }
      }

      if (parsedData.name === 'inbox' && parsedData.payload?.message) {
        console.log(parsedData.payload?.message)
      }

      if (parsedData.name === 'event' && parsedData.payload && isWeekPlanner.value) {
        if (parsedData.payload.type === 'order') {
          orderEvent(parsedData)
        } else if (parsedData.payload.type === 'update') {
          updateEvent(parsedData)
        } else if (parsedData.payload.type === 'create') {
          createEvent(parsedData)
        } else if (parsedData.payload.type === 'delete') {
          deleteEvent(parsedData)
        }
      }

      if (parsedData.name === 'task' && parsedData.payload && isTaskBoard.value && tasks.value[0].bookId === parsedData.payload.bookId) {
        if (parsedData.payload.type === 'order') {
          orderTask(parsedData)
        } else if (parsedData.payload.type === 'update') {
          updateTask(parsedData)
        } else if (parsedData.payload.type === 'create') {
          createTask(parsedData)
        } else if (parsedData.payload.type === 'delete') {
          deleteTask(parsedData)
        }
      }
    }

    ws.onclose = () => {
      ws = null
      if (needReconnection) {
        setTimeout(() => initSocket(), 1000)
      }
    }
  }

  onBeforeUnmount(() => {
    needReconnection = false
    if (ws) ws.close()
  })

  function orderEvent (parsedData) {
    parsedData.payload.value.forEach((item, index) => {
      commit('updateEvent', {
        id: item,
        order: index
      })
    })
  }

  function updateEvent (parsedData) {
    const eventEntity = state.planner.allEvents.find(item => item.id === parsedData.payload.id)

    const data = {
      id: parsedData.payload.id,
      ...eventEntity,
      showAt: parsedData.payload.value.startDate || eventEntity?.showAt,
      event: {
        ...eventEntity.event,
        ...parsedData.payload.value
      }
    }

    if (parsedData.payload.value.bookId && parsedData.payload.value.bookId !== eventEntity.bookId) {
      const books = state.book.books

      if (books.some(b => b.id === parsedData.payload.value.bookId)) {
        data.bookId = parsedData.payload.value.bookId
      } else {
        commit('deleteEvent', parsedData.payload.id)
      }
    }

    commit('updateEvent', data)
  }

  function createEvent (parsedData) {
    const bookIds = route.query.spaces.split(',').map(i => parseInt(i))

    if (bookIds.includes(parseInt(parsedData.payload.bookId))) {
      commit('addEvent', parsedData.payload.value)
    }

    commit('addToAllEvents', parsedData.payload.value)
  }

  function deleteEvent (parsedData) {
    commit('deleteEvent', parsedData.payload.value)
  }

  function orderTask (parsedData) {
    parsedData.payload.value.forEach((item, index) => {
      commit('updateTask', {
        id: item,
        order: index
      })
    })
  }

  function updateTask (parsedData) {
    commit('updateTask', {
      id: parsedData.payload.id,
      ...parsedData.payload.value
    })
  }

  function createTask (parsedData) {
    commit('addTask', parsedData.payload.value)
  }

  function deleteTask (parsedData) {
    commit('deleteTask', parsedData.payload.value)
  }

  return {
    initSocket
  }
}
